import { styled } from '@mui/material/styles'
import {
  Box,
  Badge,
  IconButton,
  BadgeProps,
  InputAdornment,
  TextField,
  useTheme,
  Avatar,
  Menu,
  MenuItem,
  useMediaQuery,
  Drawer,
} from '@mui/material'
import useCustomStyles from '../hooks/CustomStylesHook'
import SearchIcon from '@mui/icons-material/Search'
import NotificationsIcon from '@mui/icons-material/Notifications'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import { routes as appRoutes } from '../Routes'
import { useLocation, useNavigate } from 'react-router-dom'
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos'
import FullScreenButton from '../components/FullScreenButton'
import { useState } from 'react'
import KeycloakService from '../utils/keycloakService'
import MenuIcon from '@mui/icons-material/Menu'
import SideNav from './SideNav'

const styles = (theme: any) => ({
  screenHeading: {
    color: theme.palette.primary.main,
    fontSize: '20px',
    fontWeight: 500,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  notificationBtn: {
    marginRight: '1rem',
  },
  notificationIcon: {
    color: theme.palette.primary.main,
  },
  profileMenuBtn: {
    padding: 'unset',
  },
  searchField: {
    borderRadius: 20,
    fontSize: '14px',
    height: 35,
  },
  avatar: {
    height: 35,
    width: 35,
  },
})

const StyledBadge = styled(Badge)<BadgeProps>(({ theme }) => ({
  '& .MuiBadge-badge': {
    right: -3,
    top: 13,
    border: `0.5px solid ${theme.palette.background.paper}`,
    padding: '0 4px',
  },
}))

function Topbar() {
  const navigate = useNavigate()
  const location = useLocation()
  const theme = useTheme()
  const classes = useCustomStyles(styles, theme)

  const isTabletOrBelow = useMediaQuery('(max-width: 768px)')
  const [openDrawer, setOpenDrawer] = useState(false)

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  const toggleDrawer = (newOpen: boolean) => {
    setOpenDrawer(newOpen)
  }

  const routeTitle: any = appRoutes?.filter(
    (route) => route?.path === location?.pathname
  )

  const handleBack = () => {
    navigate(-1)
  }

  const handleLogout = () => {
    KeycloakService.doLogout()
  }

  return (
    <Box
      display={'flex'}
      flexDirection={'row'}
      justifyContent={'space-between'}
      alignItems={'center'}
      // pb={2}
      // pt={1}
      width={'100%'}
      flexWrap={'wrap'}
      rowGap={2}
    >
      {isTabletOrBelow && (
        <Drawer
          anchor='left'
          open={openDrawer}
          onClose={() => toggleDrawer(false)}
        >
          <SideNav />
        </Drawer>
      )}
      <Menu
        id='basic-menu-profile'
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <MenuItem onClick={handleClose}>Profile</MenuItem>
        <MenuItem onClick={handleClose}>My account</MenuItem>
        <MenuItem onClick={handleLogout}>Logout</MenuItem>
      </Menu>
      <Box className={classes?.screenHeading}>
        {isTabletOrBelow && (
          <IconButton onClick={() => toggleDrawer(true)} size='small'>
            <MenuIcon color='primary' fontSize='large' />
          </IconButton>
        )}
        {routeTitle?.[0]?.index > 8 && !isTabletOrBelow && (
          <IconButton onClick={handleBack} size='small'>
            <ArrowBackIosIcon color='primary' fontSize='small' />
          </IconButton>
        )}
        {isTabletOrBelow ? '' : routeTitle?.[0]?.title}
      </Box>
      <Box
        display={'flex'}
        flexDirection={'row'}
        justifyContent={'end'}
        alignItems={'center'}
        flexWrap={'wrap'}
        rowGap={2}
      >
        <Box mr={1}>
          <FullScreenButton />
        </Box>
        <TextField
          placeholder='Search'
          size='small'
          slotProps={{
            input: {
              className: classes?.searchField,
              endAdornment: (
                <InputAdornment position='end'>
                  <IconButton>
                    <SearchIcon />
                  </IconButton>
                </InputAdornment>
              ),
            },
          }}
        />
        <IconButton className={classes?.notificationBtn}>
          <StyledBadge badgeContent={1} color='success'>
            <NotificationsIcon className={classes?.notificationIcon} />
          </StyledBadge>
        </IconButton>
        <Box
          display={'flex'}
          flexDirection={'row'}
          justifyContent={'center'}
          alignItems={'center'}
          gap={1}
        >
          <Avatar
            alt='Remy Sharp'
            src='/static/images/avatar/1.jpg'
            className={classes?.avatar}
          />
          <Box>
            {KeycloakService?.getFullname()}
            <IconButton
              className={classes?.profileMenuBtn}
              onClick={handleClick}
            >
              <KeyboardArrowDownIcon fontSize='small' />
            </IconButton>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default Topbar
